<template>
    <div class="business">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
  
            <template >
              <!-- <div class="row">
                <div class="col-6">Section 24 (Housing Loan)</div>
                <div class="col-6 align-right">Rs. 3,60,000</div>
              </div> -->
            </template>
            <template >
              <div v-if="regimeType == ('Old Regime' || 'oldregime')" class="datatable-outer-container">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th>(i)Interest on housing loan (Self occupied)</th>
                      <th>Planned</th>
                      <!-- <th>Actual</th> -->
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <!-- <tr
                    v-for="(item, index) in section24.self_occupied.selfOccupied"
                    :key="index"
                    class="record-row"
                  >
                    <td>{{item.name}}</td>
                    <td>
                      <txt
                        type="number"
                        :name="'soplanned'+index"
                        :disable="false"
                        v-model="item.planned"
                        @change=" calculateTotal(item)"
                      />
                    </td>
                    <td>
                      <txt
                        type="number"
                        :name="'soactual'+index"
                        v-model="item.actual"
                        @change="sumSelfOccupied()"
                      />
                    </td>
                    <td></td>
                    <td></td>
                  </tr> -->
                  <tr class="record-row">
                    <td>
                      <b>Total</b>
                    </td>
                    <td>
                      <txt
                        type="number"
                        name="total_planned"
                        :disable="false"
                        v-model="section24.self_occupied.total_planned"
                        @change=" (val)=> calculateTotal(val)"
                      />
                    </td>
                    <!-- <td>
                      <txt
                        type="number"
                        name="total_actual"
                        :disable="false"
                        v-model="section24.self_occupied.total_actual"
                      />
                    </td> -->
                    
                  </tr>
                </table>
              </div>
              <div v-if="regimeType == ('Old Regime' || 'oldregime')"  class="d-payroll__accord margin-t-m">
                <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveHLOthers = !isActiveHLOthers"
                  >Self - Decaration for Joint Property</div>
                  <div class="accordContent">
                    <div class="row">
                      <div class="jointPropertyContainer">
                        <!-- <div class="icon"> -->
                          <!-- <div class="row"> -->
                            <div class="">
                              <txt
                                label="Name of Joint Holder"
                                name="joint_holder_name"
                                v-model="section24.self_occupied.joint_holder_name"
                              />
                            </div>
                          <!-- </div> -->
                          <!-- <div class="row margin-t-s"> -->
                            <div class="">
                              <txt
                                label="Relationship"
                                name="relationship"
                                v-model="section24.self_occupied.relationship"
                              />
                            </div>
                          <!-- </div> -->
                          <!-- <div class="row margin-t-s"> -->
                            <div class="">
                              <span class="jointPropertyText">% of tax benefit claimed by joint Holder</span>
                              <txt
                                name="tax_benefit"
                                :type="number"
                                v-validate="{ regex:percentageRegex }"
                                :classname="errors.has('tax_benefit')"
                                errormsg="Please provide 1-100 percentage value"
                                v-model="section24.self_occupied.tax_benefit"
                                @change=" (val)=> calculateTaxBenefit(val)"
                              />
                            </div>
                          <!-- </div> -->
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p  v-if="totalRent" class="totalRent">*Total rent recieved by employee must be greater than Muncipal taxes</p>
              <div v-for="(letout, index) in section24.let_out_property" :key="index">
                <div class="flex">
                  <div class="align-right" v-if="section24.let_out_property.length > 0">
                    <a class="delete-btn" @click="deleteLetOut(index)">
                      <img src="@/assets/delete.svg" />
                      <span>Delete LetOut Property</span>
                    </a>
                  </div>
                </div>
                <div class="datatable-outer-container">
                  <table class="datatable">
                    <thead>
                      <tr class="header-row">
                        <th>(ii)Income/loss from house property (Letout)</th>
                        <th>Planned</th>
                        <!-- <th>Actual</th> -->
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tr v-for="(item, idx) in letout.letOut" :key="idx" class="record-row">
                      <td>{{item.name}}</td>
                      <td>
                        <txt
                          type="number"
                          :name="'loplanned'+idx"
                          @change="calculate(letout.letOut, index)"
                          :disable="item.isDisabled"
                          v-model="item.planned"
                        />
                      </td>
                      <!-- <td>
                        <txt
                          type="number"
                          v-if="!item.isCalculate"
                          :name="'loactual'+idx"
                          v-model="item.actual"
                          @change="sumLetOutActual(index)"
                          :disable="item.isDisabled"
                        />
                        <txt
                          type="number"
                          v-else
                          :name="'loactual'+idx"
                          v-model="item.actual"
                          @change="calculateOther(index, idx, item.name); sumLetOutActual(index)"
                          :disable="item.isDisabled"
                        />
                      </td> -->
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="record-row">
                      <td>
                        <b>Total</b>
                      </td>
                      <td>
                        <txt
                          type="number"
                          :name="'totalletoutPlanned'+index"
                          :disable="true"
                          v-model="letout.total_planned"
                        />
                      </td>
                      <!-- <td>
                        <txt
                          type="number"
                          :name="'totalletoutActual'+index"
                          :disable="false"
                          v-model="letout.total_actual"
                        />
                      </td> -->
                      
                    </tr>
                  </table>
                </div>
                <div class="d-payroll__accord margin-t-m">
                  <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                    <div
                      class="it_accordHeading d-heading"
                      @click="isActiveHLOthers = !isActiveHLOthers"
                    >Self - Decaration for Joint Property</div>
                    <div class="accordContent">
                      <div class="row">
                        <div class="jointPropertyContainer">
                          <!-- <div class="icon">
                            <div class="row"> -->
                              <div class="">
                                <txt
                                  label="Name of Joint Holder"
                                  :name="'letout_joint_holder_name'+index"
                                  v-model="letout.joint_holder_name"
                                />
                              </div>
                            <!-- <div class="row margin-t-s"> -->
                              <div class="">
                                <txt
                                  label="Relationship"
                                  :name="'letout_relationship'+index"
                                  v-model="letout.relationship"
                                />
                              </div>
                            <!-- </div> -->
                            <!-- <div class="row margin-t-s"> -->
                              <!-- <div class="col-4 margin-t-s">% of tax benefit claimed by joint Holder</div> -->
                              <div class="">
                                <span>% of tax benefit claimed by joint Holder</span>
                                <txt
                                  type="number"
                                  :name="'tax_benefit'+index"
                                  v-model="letout.tax_benefit"
                                  v-validate="{ regex:percentageRegex }"
                                  :classname="errors.has('tax_benefit'+index)"
                                  errormsg="Please provide 1-100 percentage value"
                                  @change="calculate(letout.letOut, index)"
                                />
                              </div>
                            <!-- </div> -->
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
    
              </div>
              <div class="datatable-outer-container">
                  <table class="datatable">
                    <tbody>
                      <tr class="record-row">
                        <td>
                          <b>Total Exemption</b>
                          <p>Either 2 Lakhs or (i+ii)</p>
                        </td>
                        <td>
                          <txt type="number" name="totalPlanned" v-model="totalExemptionPlanned" :disable="false" />
                        </td>
                        <td>
                          <txt type="number" name="totalPlanned" v-model="totalExemption" :disable="false" />
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              <div class="row margin-t-m margin-b-l">
                <div class="col-12">
                  <div class="row-container align-center">
                    <img src="@/assets/group-5.svg" class="Group-5" />
                    <button class="text-green" @click="addMoreLetOut()">Add More Housing Properties</button>
                  </div>
                </div>
              </div>
            </template>
  
         <footer>
          <popup-bottom-container>
            <template slot="end">
              <btn-grp class="form-button">
                <btn text="Cancel" type="secondary" @click="goBack"/>
                <btn :text="saveAsDraft ? 'Save as Draft' : 'Save'" type="primary" v-if="itEnableValue"  :disabled="totalRent" @click="submitData" />
              </btn-grp>
            </template>
          </popup-bottom-container>
        </footer>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "incomeLossFromHousingProperty",
    props: {
      Section24:{
        type: Object
      },
      saveAsDraft: {
        type: Boolean
      },
      itEnableValue:{
      type: String,
      required: true
    },
    regimeType :{
      type: String,
      required:true
    }
    },
    data() {
      return {
        percentageRegex: /^(?:100|[1-9]?[0-9]|0)$/,
        errmsg: "",
        toast: false,
        showSuccessMsg: false,
        selfOccupiedPropertyBlock: true,
        letOutPropertyBlock: true,
        selfOccupiedProperty: false,
        letOutProperty: false,
        hrLine: true,
        totalRent:false,
        isActiveHLOthers:true,
        section24: {
          let_out_property: [
          {
            letOut: [
            {
              name: "Current Year Interest",
              planned: 0,
              actual: 0,
              approved: 0,
            },{
              name: "A Total rent received by employee",
              planned: 0,
              actual: 0,
              approved: 0,
              isCalculate: true
            },
            {
              name: "B Less: municipal Taxes Paid",
              planned: 0,
              actual: 0,
              approved: 0,
              isCalculate: true
            },
            {
              name: "C (A-B) Net Annual Value",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "D (C* 30%) Less: Standard Deduction @ 30%",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "E Less: Interest on Housing Loan",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "F (C-D-E) Income/Loss on House Property",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            }
            ],
            total_planned: 0,
            total_actual: 0,
            total_approved: 0,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0
          }
          ],
          self_occupied: {
            selfOccupied: [],
            total_planned: 0,
            total_actual: 0,
            total_approved: 0,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0
        }
        },
        totalExemption: 0,
        totalExemptionPlanned: 0,
      };
    },
    computed: {},
  
    mounted() {
      this.showSuccessMsg = false;
      this.load();
      let result = 0;
      let self_occupied_total_planned = 0;
      // let total= 0;
          let self_occupied_tax_benefit = this.section24.self_occupied.tax_benefit;
          if(self_occupied_tax_benefit > 0){
            let tax_benefit_perc = this.section24.self_occupied.total_planned * (self_occupied_tax_benefit/100);
            self_occupied_total_planned = this.section24.self_occupied.total_planned - tax_benefit_perc;
          }else{
            self_occupied_total_planned = this.section24.self_occupied.total_planned
          }
          this.section24.let_out_property.map(el => {
            result += el.total_planned
          });
          //console.log(total, result);
      this.totalExemptionPlanned = (-self_occupied_total_planned + result < -200000) ? -200000 : -self_occupied_total_planned + result;
      this.totalExemption = this.Section24.let_out_property[0].total_actual + this.section24.self_occupied.total_actual;
    },
  
    activated() {    
      this.toast = false;
      this.errmsg = "";
      this.showSuccessMsg = false;
    },
  
    methods: {
      load(){
          let section24data = this.Section24;
            if (Object.keys(this.Section24).length) {
              if (this.Section24.let_out_property.length) {
                this.section24.let_out_property = this.Section24.let_out_property;
              }
              this.section24.self_occupied = this.Section24.self_occupied;
              this.section24.self_occupied.total_planned = Math.abs(this.section24.self_occupied.total_planned);
            } 
      },
       submitData() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.calculateLoadTotal();
            this.section24.grandTotal = this.totalExemptionPlanned;
            this.$emit("incomeLossFromHousingProperty", this.section24)
          } else {
            // to navigate to error fields(PL- 1872) - 28/11/2019
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        })
      },
      addSelfOccupiedProperty() {
        this.selfOccupiedPropertyBlock = false;
        this.letOutPropertyBlock = false;
        this.selfOccupiedProperty = true;
        this.letOutProperty = false;
        this.hrLine = false;
      },
      addLetOutProperty() {
        this.selfOccupiedPropertyBlock = false;
        this.letOutPropertyBlock = false;
        this.selfOccupiedProperty = false;
        this.letOutProperty = true;
        this.hrLine = false;
      },
      calculate(item, index){
          if(item[2].planned>item[1].planned){
            this.totalRent = true;
          }else{
            this.totalRent = false;
          }
          item[3].planned = item[1].planned-item[2].planned;
          item[4].planned = (item[3].planned)*0.3;
          item[5].planned = item[0].planned;
          item[6].planned = (item[3].planned-item[4].planned)-item[5].planned;
          let tax_benefit = this.section24.let_out_property[index].tax_benefit;
          this.section24.let_out_property[index].total_planned = this.section24.let_out_property[index].letOut[6].planned;
          if(tax_benefit > 0){
            let tax_benefit_perc = this.section24.let_out_property[index].letOut[6].planned * (tax_benefit/100);
            this.section24.let_out_property[index].total_planned = this.section24.let_out_property[index].letOut[6].planned - tax_benefit_perc;
          }
         // let total= 0;
          let self_occupied_tax_benefit = this.section24.self_occupied.tax_benefit;
          let section24_self_occupied_total_planned = 0;
          if(self_occupied_tax_benefit > 0){
            let tax_benefit_perc = this.section24.self_occupied.total_planned * (self_occupied_tax_benefit/100);
            section24_self_occupied_total_planned = this.section24.self_occupied.total_planned - tax_benefit_perc;
          }else{
            section24_self_occupied_total_planned = this.section24.self_occupied.total_planned
          }
          let result = null;
          this.section24.let_out_property.map(el => {
            result += el.total_planned
          });
          this.totalExemptionPlanned = (-section24_self_occupied_total_planned + result < -200000) ? -200000 : -section24_self_occupied_total_planned + result;
        },
  
      calculateTotal(val) {
        let total= 0;
        let self_occupied_tax_benefit = this.section24.self_occupied.tax_benefit;
        if(self_occupied_tax_benefit > 0){
          let tax_benefit_perc = val * (self_occupied_tax_benefit/100);
          total = val - tax_benefit_perc;
        }else{
          total = val;
        }
        let result = null;
          this.section24.let_out_property.map(el => {
            result += el.total_planned
          });
          this.totalExemptionPlanned = (-total + result < -200000) ? -200000 : -total+ result;
      },

      calculateTaxBenefit(val){
        let total= 0;
        let self_occupied_tax_benefit = val;
        if(self_occupied_tax_benefit > 0){
          let tax_benefit_perc = this.section24.self_occupied.total_planned * (self_occupied_tax_benefit/100);
          total = this.section24.self_occupied.total_planned - tax_benefit_perc;
        }else{
          total = this.section24.self_occupied.total_planned
        }
        let result = null;
          this.section24.let_out_property.map(el => {
            result += el.total_planned
          });
          this.totalExemptionPlanned = (-total + result < -200000) ? -200000 : -total+ result;
      },

      calculateLoadTotal() {
        let result = 0;
        let self_occupied_total_planned = 0;
        // let total= 0;
        let self_occupied_tax_benefit = this.section24.self_occupied.tax_benefit;
        if(self_occupied_tax_benefit > 0){
          let tax_benefit_perc = this.section24.self_occupied.total_planned * (self_occupied_tax_benefit/100);
          self_occupied_total_planned = this.section24.self_occupied.total_planned - tax_benefit_perc;
        }else{
          self_occupied_total_planned = this.section24.self_occupied.total_planned
        }
        this.section24.let_out_property && this.section24.let_out_property.map(el => {
          result += el.total_planned
        });
        this.totalExemptionPlanned = (-self_occupied_total_planned + result < -200000) ? -200000 : -self_occupied_total_planned + result;
      },
  
      calculatFY() {
        try {
          let d = new Date();
          let year = d.getFullYear();
          this.section24.self_occupied.selfOccupied = [
            {
              name: "Current Year Interest",
              planned: 0,
              actual: 0,
              approved: 0
            }
          ];
          for (let i = 1; i <= 5; i++) {
            let next_year = year - i;
            this.section24.self_occupied.selfOccupied.push({
              name: "Pre EMI Interest " + (year - i + "-" + (next_year + 1)),
              planned: 0,
              actual: 0,
              approved: 0
            });
          }
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      calculateLetOutFy() {
        try {
          let d = new Date();
          let year = d.getFullYear();
  
          this.section24.let_out_property.forEach(element => {
            element.letOut = [
              {
                name: "Current Year Interest",
                planned: 0,
                actual: 0
              }
            ];
            // removed temporary will take back if need 
            // for (let i = 1; i <= 5; i++) {
            //   element.letOut.push({
            //     name: "Pre EMI Interest FY" + i,
            //     planned: 0,
            //     actual: 0
            //   });
            // }
            element.letOut.push(
              {
                name: "A Total rent recieved by employee",
                planned: 0,
                actual: 0,
                approved: 0,
                isCalculate: true
              },
              {
                name: "B Less: municipal Taxes Paid",
                planned: 0,
                actual: 0,
                approved: 0,
                isCalculate: true
              },
              {
                name: "C (A-B) Net Annual Value",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              },
              {
                name: "D (C* 30%) Less: Standard Deduction @ 30%",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              },
              {
                name: "E Less: Interest on Housing Loan",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              },
              {
                name: "F (C-D-E) Income/Loss on House Property",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              }
            );
          });
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      calculateOther(letOutIndex, rowIndex, name) {
        try {
          let obj1 = {};
          let index = 0;
          let obj2 = {};
          if (name == "A Total rent recieved by employee") {
            index = rowIndex + 2;
            obj2 = this.section24.let_out_property[letOutIndex].letOut[
              rowIndex + 1
            ];
            obj1 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
          } else {
            index = rowIndex + 1;
            obj2 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
            obj1 = this.section24.let_out_property[letOutIndex].letOut[
              rowIndex - 1
            ];
          }
          this.section24.let_out_property[letOutIndex].letOut[index].actual =
            obj1.actual - obj2.actual;
         // this.section24.let_out_property[letOutIndex].letOut[index + 1].actual =
            // (30 *
            //   this.section24.let_out_property[letOutIndex].letOut[index].actual) /
            // 100;
          this.section24.let_out_property[letOutIndex].letOut[index + 3].actual =
            this.section24.let_out_property[letOutIndex].letOut[index].actual -
            this.section24.let_out_property[letOutIndex].letOut[index + 1]
              .actual -
            this.section24.let_out_property[letOutIndex].letOut[index + 2].actual;
            //console.log("section24",this.section24);
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      sumSelfOccupied() {
        try {
          let sum = 0;
          this.section24.self_occupied.selfOccupied.forEach(element => {
            sum += element.actual;
          });
          this.section24.self_occupied.total_actual = sum;
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      sumLetOutActual(index) {
        try {
          // let sum = 0;
          // this.section24.let_out_property[index].letOut.forEach(item => {
          //   sum += item.actual;
          // });
          this.section24.let_out_property[index].total_actual = this.section24.let_out_property[index].letOut[0].actual -this.section24.let_out_property[index].letOut[6].actual;
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
       addMoreLetOut() {
        try {
          this.section24.let_out_property.push({
            letOut: [
            {
                name: "Current Year Interest",
                planned: 0,
                actual: 0,
                approved: 0,
              },{
                name: "A Total rent recieved by employee",
                planned: 0,
                actual: 0,
                approved: 0,
                isCalculate: true
              },
              {
                name: "B Less: municipal Taxes Paid",
                planned: 0,
                actual: 0,
                approved: 0,
                isCalculate: true
              },
              {
                name: "C (A-B) Net Annual Value",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              },
              {
                name: "D (C* 30%) Less: Standard Deduction @ 30%",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              },
              {
                name: "E Less: Interest on Housing Loan",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              },
              {
                name: "F (C-D-E) Income/Loss on House Property",
                planned: 0,
                actual: 0,
                approved: 0,
                isDisabled: true
              }
            ],
            total_planned: 0,
            total_actual: 0,
            total_approved: 0,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0
          });
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      deleteLetOut(index) {
        try {
          this.section24.let_out_property.splice(index, 1);
          let self_occupied_total_planned = 0;
          // let total= 0;
          let self_occupied_tax_benefit = this.section24.self_occupied.tax_benefit;
          if(self_occupied_tax_benefit > 0){
            let tax_benefit_perc = this.section24.self_occupied.total_planned * (self_occupied_tax_benefit/100);
            self_occupied_total_planned = this.section24.self_occupied.total_planned - tax_benefit_perc;
          }else{
            self_occupied_total_planned = this.section24.self_occupied.total_planned
          }
          let result = null;
          this.section24.let_out_property.map(el => {
            result += el.total_planned
          });
          this.totalExemptionPlanned = (-self_occupied_total_planned + result < -200000) ? -200000 : -self_occupied_total_planned + result;
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
  
      // Add here code for cancel button to hide popup By Bhushan 
      goBack() {
        this.$emit('back');
      }
      
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  // .business {
  //   width: 100%;
  //   height: 100%;
  // }
  
  // .business .top-bar {
  //   height: auto;
  //   padding: 20px;
  //   background-color: #34c0be;
  //   display: flex;
  // }
  
  
  .title-income {
    font-size: 1.1rem;
    font-weight: 600;
    color: #444444;
  }
  
  .jointPropertyContainer{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 15px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .jointPropertyText{
    margin-bottom: 20px;
  }

  .flex{
    display: flex;
    justify-content: flex-end;
  }
  .totalRent{
    color: #E64848;
    font-size: 1rem;
    margin-top: 30px;
    margin-bottom: -25px;
  }
  
  .title-income-normal-left {
    font-size: 1.0rem;
    color: #444444;
  }
  
  .title-income-normal-right {
    font-size: 1.0rem;
    color: #444444;
    text-align: right;
  }
  
  .title-income-left {
    font-size: 1.1rem;
    font-weight: 600;
    color: #444444;
  }
  
  .title-income-right {
    font-size: 1.1rem;
    font-weight: 600;
    color: #444444;
    text-align: right;
  }
  
  .section-table {
    padding: 24px 0px;
  }
  
  .datatable-outer-container {
    width: 100%;
  }
          
  .datatable-outer-container table.datatable {
              width: 100%;
              border-collapse: collapse;
              margin: 0 auto;
              font-family: Montserrat;
              margin-bottom: 4px;
  }
          
          .datatable-outer-container table.datatable .header-row {
              background-color: white;
              height: 54px;
          }
          
          .datatable-outer-container table.datatable .header-row th {
              background-color: #f0f1f5;
              border-bottom: 1px solid #34c0be;
              padding: 6px 8px;
          }
          
          .datatable-outer-container table.datatable .header-row th .tl-checkbox {
              text-align: center;
          }
          
          .datatable-outer-container table.datatable .inactiveCols {
              opacity: 0.03;
              background-color: #a2a1a1;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader {
              background-color: #ffffff;
              -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
              box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th {
              padding: 0 8px;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th span {
              border-right: 1px solid #ececec;
              padding: 0px 18px 0px 15px;
              display: inline-block;
              vertical-align: middle;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
              padding: 10px 10px 7px 10px;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
              text-align: right;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
              border-right: none;
              font-weight: 400;
              font-style: italic;
              position: relative;
          }
          
          .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
              position: absolute;
              right: 10px;
              top: 2px;
          }
          
          .datatable-outer-container table.datatable .record-row {
              height: 54px;
              border-bottom: 1px solid #d8d8d8;
          }
          
          .datatable-outer-container table.datatable .record-row:nth-child(odd) {
              background-color: #f5f6fa;
          }
          
          .datatable-outer-container table.datatable .record-row.selectedRecord {
              background-color: #E9F9F8;
              opacity: 0.9;
          }
          
          .datatable-outer-container table.datatable .record-row td {
              padding: 6px 8px;
              color: #646464;
              font-weight: 500;
          }
          
          .datatable-outer-container table.datatable .record-row td .tl-checkbox {
              text-align: center;
          }
          
          .datatable-outer-container table.datatable .record-row .actions {
              width: 10%;
              padding: 10px;
          }
          
          .datatable-outer-container table.datatable .record-row .row-item {
              padding: 6px 8px;
          }
          
          .datatable-outer-container table.datatable .record-row .row-item p {
              width: 100%;
              margin-bottom: 0px;
          }
          
          .datatable-outer-container table.datatable .record-row .action-img {
              display: inline-block;
              cursor: pointer;
              opacity: 0;
          }
          
          .datatable-outer-container table.datatable .record-row:hover .action-img {
              opacity: 1;
          }
  
  .add-self-occupied-property {
    width: 379px;
    height: 120px;
    padding: 24px 16px 24px 16px;
    border-radius: 4px;
    border: 2px solid #dddddd;
    background-color: #ffffff;
    cursor: pointer;  
    margin: 30px 0px;
  }
  
  .center-block-add-new {
    padding: 16px 0;
    text-align: center;
  }
  
  .block-add-new-icon {
    transform: translate(0px, 5px);
  }
  
  .add-new {
    height: 18px;
    margin: 3px 0 3px 6px;
    font-size: 14px;
    font-weight: bold;
    color: #37c6c0;
  }
  
  .inputbox{
     width: 149px;
    height: 35px;
    // width: 30%;
    padding: 4px;
    border: 1px solid #c6c9c8;
    border-radius: 4px;
    &:focus {
          outline: none;
          border: 2px solid #37c6c0;
      }
  }
  
  .block-1 {
    width: 400px;
    margin: 10px 0;
    display: inline-block;
    font-weight: 500;
    font-size: 1.2rem;
  }
  
  .block-2 {
    display: inline-block;
    width: 50%;
    margin: 10px 0;
  }
  
  .title-joint-property {
    margin: 15px 0;
    font-weight: 600;
    font-size: 1.2rem;
  }
  
  .inputbox-large{
    height: 35px;
    width: 30%;
    padding: 4px;
    border: 1px solid #c6c9c8;
    border-radius: 4px;
    &:focus {
          outline: none;
          border: 2px solid #37c6c0;
      }
  }
  </style>
  